import { type ReactNode } from "react";

interface PullQuoteProps {
  quote: string;
  mark?: ReactNode;
}

export function PullQuote({ quote, mark }: PullQuoteProps) {
  return (
    <div className="my-16 py-12 border-y border-[#293129]/20 flex flex-col items-center text-center">
      {mark && <div className="mb-6">{mark}</div>}
      <p className="font-serif text-2xl md:text-4xl italic max-w-lg">
        &ldquo;{quote}&rdquo;
      </p>
    </div>
  );
}
